export default __webpack_public_path__ + "static/media/demo_version_img.e1768bd6.png";